
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  name: 'ContactUs',
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      a: Math.ceil(Math.random() * 10),
      b: Math.ceil(Math.random() * 10),
      showError: false,
      answer: null,
      form: {},
      messageSent: false,
    }
  },
  computed: {
    bottest() {
      return `What is ${this.a} + ${this.b} ?`
    },
    c() {
      return parseInt(this.a + this.b)
    },

  },
  methods: {
    async Submit() {
      console.log('Submit the form')
      this.loading = true
      let result = await this.$axios
        .$post(`${process.env.SERVERLESS_API_URL}/email/send`, this.form)
        .catch((error) => {
          console.log('Error', error)
        })
   result=JSON.parse(result.slice(9))
      if (result.messageId) {
        this.messageSent = true
      }
    },
  },
}
